import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import mainTabActions from "../../_actions/mainTabActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../_common/AlertModal";
import "./styles/nav.css";

class MainTabs extends Component {
  state = {
    showClose: false,
    currentMouseOverTabId: "",
    showAlert_saveWarn: false,
    tabToClose: null,
  };

  showCloseOnMouseOver = (tabId) => () =>
    this.setState({ showClose: true, currentMouseOverTabId: tabId });

  hideCloseOnMouseOut = () => this.setState({ showClose: false });

  handleClick_tab = (tab) => (e) => {
    e.preventDefault();
    this.props.dispatch(mainTabActions.selectTab(tab.tabId));
    this.props.dispatch(push(tab.link));
  };

  handleClick_tabClose = (tabToClose) => (e) => {
    const { dispatch } = this.props;
    e.preventDefault();
    e.stopPropagation();

    this.setState({ tabToClose });

    if (tabToClose.contentIsModified) this.toggleAlert_saveWarn();
    else dispatch(mainTabActions.closeTab(tabToClose.tabId));
  };

  toggleAlert_saveWarn = () =>
    this.setState({ showAlert_saveWarn: !this.state.showAlert_saveWarn });

  handleAlert_saveWarn = (alertAction) => (e) => {
    const { dispatch } = this.props;
    const { tabToClose } = this.state;
    e.preventDefault();
    if (alertAction === "accept") dispatch(mainTabActions.closeTab(tabToClose.tabId));
    this.toggleAlert_saveWarn();
  };

  render() {
    const { openTabs, selectedTabId } = this.props;
    const { showClose, currentMouseOverTabId, showAlert_saveWarn } = this.state;
    return (
      <React.Fragment>
        <div className="dms-main-tabs mt-2 mx-1">
          <ul className="nav nav-tabs border-0 dms-main-nav-tabs">
            {openTabs.map((tab) => {
              // Do not show close icon for the Home tab.
              // Home tab is a fixed permanent resident that has tabId of 0.
              if (tab.tabId === 0) {
                return (
                  <li className="nav-item" key="mmtKey_0">
                    <Link
                      className={
                        tab.tabId === selectedTabId
                          ? "nav-link active border border-secondary border-bottom-0"
                          : "nav-link border border-secondary border-bottom-0"
                      }
                      to={tab.link}
                      id="tab_0"
                      onClick={this.handleClick_tab(tab)}
                      onTouchEnd={this.handleClick_tab(tab)}
                      data-toggle="tab"
                      role="tab"
                    >
                      {tab.label}
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li className="nav-item" key={`mmtKey_${tab.tabId}`}>
                    <Link
                      className={
                        tab.tabId === selectedTabId
                          ? "nav-link active border border-secondary border-bottom-0"
                          : "nav-link border border-secondary border-bottom-0"
                      }
                      to={tab.link}
                      id={"tab_" + tab.tabId}
                      onClick={this.handleClick_tab(tab)}
                      onTouchEnd={this.handleClick_tab(tab)}
                      onMouseOver={this.showCloseOnMouseOver(tab.tabId)}
                      onMouseOut={this.hideCloseOnMouseOut}
                      data-toggle="tab"
                      role="tab"
                    >
                      {tab.label}
                      {tab.contentIsModified ? " *" : ""}
                      <span key="dummy1" className="ml-2" />
                      <span key={tab.tabId}>
                        {showClose && tab.tabId === currentMouseOverTabId ? (
                          <FontAwesomeIcon
                            key={tab.tabId}
                            icon="times"
                            className="mt-1"
                            id={"tabClose_" + tab.tabId}
                            onClick={this.handleClick_tabClose(tab)}
                            onTouchEnd={this.handleClick_tabClose(tab)}
                          />
                        ) : selectedTabId !== tab.tabId ? (
                          <FontAwesomeIcon
                            key={tab.tabId}
                            icon="times"
                            className="mt-1 icon-invisible"
                          />
                        ) : (
                          <FontAwesomeIcon
                            key={tab.tabId}
                            icon="times"
                            className="mt-1"
                            id={"tabClose_" + tab.tabId}
                            onClick={this.handleClick_tabClose(tab)}
                            onTouchEnd={this.handleClick_tabClose(tab)}
                          />
                        )}
                      </span>
                    </Link>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        {showAlert_saveWarn && (
          <AlertModal
            alertTitle="Unsaved Changes"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={`There are unsaved changes.\nAny unsaved data will be lost after closing this tab.`}
            acceptCaption={"Close"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"Keep Open"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_saveWarn}
            toggleAlertModal={this.toggleAlert_saveWarn}
            showAlertModal={showAlert_saveWarn}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  openTabs: state.mainTabs.openTabs,
  selectedTabId: state.mainTabs.selectedTabId,
});

export default connect(mapStateToProps)(MainTabs);
